import { Navigate, useParams } from 'react-router-dom';
import { useGetCurrentUser } from 'apis/user/hook';
import { useGetBusinessProfile } from '@/apis/business/hook';
import Spinner from 'components/Common/Spinner';
import * as urls from 'routes/config';

type Props = { outlet: JSX.Element };

export default function AllowBehaviourEditable({ outlet }: Props) {
  const { locationId, agentId } = useParams();
  const { data: currentUser, isLoading: isUserLoading } = useGetCurrentUser();
  const { data: businessProfile, isLoading: isProfileLoading } = useGetBusinessProfile();

  const isAgencyUser = ['agency_admin', 'agency_admin_readonly', 'agent_builder'].includes(currentUser?.role ?? '');
  const canEditBehaviour = isAgencyUser || Boolean(businessProfile?.behaviour_editable);

  if (isUserLoading || isProfileLoading) {
    return <Spinner />;
  }

  if (canEditBehaviour) {
    return outlet;
  }

  return (
    <Navigate to={`${urls.agentBase(locationId, agentId)}/${urls.home.configure}/${urls.configure.identity}`} replace />
  );
}
